/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class NoxiousIsIntroducedValidator extends BaseValidator {
	name(model) {
		return this.message(model);
	}

	logic(x, model, data, customData) {
		const noxiousInvasivityId = 1; // noxious
		const introducedNativityId = 2; // invasive
		const invasivityId = data?.speciesInvasivityId;
		const nativityId = data?.speciesNativityId;

		if (Number(invasivityId) === Number(noxiousInvasivityId)) {
			return Number(nativityId) === Number(introducedNativityId);
		}
		// else if (Number(nativityId) === Number(introducedNativityId)) {
		//     return Number(invasivityId) === Number(noxiousInvasivityId);
		// }

		return true;
	}

	message(model) {
		return 'Nativity must be "Introduced" when Invasivity is "Noxious"';
	}
}